export default __webpack_public_path__ + "static/media/da87a9056144110d4a99fe41ccb465c0.png";